import React from "react";
import { Box, Stack, Typography} from "@mui/material";

function PageTopElements(props) {
    return ( 
            <>
            <Stack style={{position:"relative"}} sx={{ justifyContent: "flex-end", alignItems: "flex-end"}}>
            <Stack component="img" sx={{ minHeight: "200px", maxHeight: "200px", minWidth: "300px", maxWidth: "300px", objectFit:"cover"}}
                alt={props.alt}
                src={props.img} />

            <Box style={{position: "absolute" }}>
                <Typography mr="20px" variant="h4" fontStyle="italic" fontWeight="600" sx={{ textTransform: "uppercase", color: "white", textAlign: "right" }}>
                    {props.text}
                </Typography>
            </Box>
        </Stack>
            </>
               
    );
};
export default PageTopElements;

